module.exports = __webpack_public_path__ + "img/Weilin Communication Center Software.ab2b9625.jpg";